
import { handleLegalClick } from "./analytics";

const LegalSection = () => {
  return (
    <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
      <p className="text-white/60 text-sm text-center md:text-left">
        © {new Date().getFullYear()} Front Runner. All rights reserved.
      </p>
      <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6 items-center md:items-start">
        <a 
          href="/terms"
          onClick={() => handleLegalClick('Terms')}
          className="text-white/60 hover:text-white text-sm transition-colors"
        >
          Terms & Conditions
        </a>
        <a 
          href="/privacy"
          onClick={() => handleLegalClick('Privacy')}
          className="text-white/60 hover:text-white text-sm transition-colors"
        >
          Privacy Policy
        </a>
      </div>
    </div>
  );
};

export default LegalSection;
